import Vue from 'vue'
import axios from 'axios';

import App from './App.vue';
import Admin from './Admin.vue';

Vue.prototype.$axios = axios;
Vue.prototype.$makeForm = (object) => {
    let form = new FormData;
    for (let key in object) {
        if (object.hasOwnProperty(key)) {
            form.append(key, object[key]);
        }
    }
    return form;
};


new Vue({
    el: '#cover-calculator',
    components: {
        App,
        Admin,
    }
})



// WEBPACK FOOTER //
// ./src/main.js